import api from './api';

export async function fetchFileMonitoringData() {
  const { data } = await api.get('/api/file-monitoring');
  return data;
}
